export default "__VITE_ASSET__DBw_xujt__"